const types = {
  403: {
    img: "https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg",
    title: "禁止访问",
    desc: "抱歉，你无权访问该页面"
  },
  404: {
    img: "https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg",
    title: "功能开发中",
    desc: "抱歉，你访问页面的正在开发中"
  },
  500: {
    img: "https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg",
    title: "服务器内部错误",
    desc: "抱歉，服务器出错了"
  }
};

export default types;
